import script from "./income.vue?vue&type=script&setup=true&lang=js"
export * from "./income.vue?vue&type=script&setup=true&lang=js"

import "./income.vue?vue&type=style&index=0&id=f219b1ec&lang=less&scoped=true"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f219b1ec"]])

export default __exports__